import PropTypes from "prop-types";

const RetroLoader = ({ text = "Ladataan..." }) => {
  return (
    <div
      className="
        flex flex-col items-center justify-center gap-6 py-16
        text-center
      "
      role="status"
      aria-live="polite"
    >
      {/* Spinner */}
      <div
        className="
          relative flex h-20 w-20 items-center justify-center rounded-full
          border border-primary/20 bg-white/70 shadow-inner
          dark:border-primary/20 dark:bg-[#111114]/80
        "
        aria-hidden="true"
      >
        <div
          className="
            absolute inset-2 rounded-full border-4 border-transparent
            border-t-primary border-r-primary
            animate-spin
          "
        />

        <div
          className="
            absolute inset-5 rounded-full border-4 border-transparent
            border-b-accent border-l-accent
            [animation:spin_1.1s_linear_infinite_reverse]
          "
        />

        <div
          className="
            h-3 w-3 rounded-full bg-primary shadow-[0_0_18px_rgba(24,214,190,0.7)]
          "
        />
      </div>

      {/* Teksti */}
      <p
        className="
          max-w-sm font-customFont1 text-base font-extrabold tracking-wide
          !text-[#111827]
          dark:!text-white
          sm:text-lg
        "
      >
        {text}
      </p>
    </div>
  );
};

RetroLoader.propTypes = {
  text: PropTypes.string,
};

export default RetroLoader;